import factory from '../requestFactory';
import store from '@/store'

export default () => {
    let patient_id = store.getters.patient.id
    return factory()
        .get(`/patient/diagnostic-files/${patient_id}/files-list`)

};
